import sdl from '@jds/react-generated-sdl/JDSSearchResultText';
import type { JDSSearchResultTextProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSearchResultTextProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { bold = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { bold, ...rest },
    'JDSSearchResultText',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SearchResultText = withLogic(
  Component
) as React.FC<JDSSearchResultTextProps> & { slotName?: string };

SearchResultText.displayName = 'SearchResultText';
SearchResultText.slotName = 'jds_search_result_text';

export { SearchResultText, type JDSSearchResultTextProps };
